import React from 'react';

import { isTypingTarget } from '../../helpers/links_to_check_flow_helpers';
import { getSkipSheet } from '../../helpers/links_to_check_helpers';
import { useWindowKeydown } from '../../hooks/useWindowKeydown';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './SkipReasonSheet.scss';

/** Why the link is skipped, from the fixed list, with a way to link it instead when it is in the catalog. */
const SkipReasonSheet = () => {
  const { link, isKeysOpen, answer, openPane, closeSheet } = useLinksToCheckContext();
  const { title, reasons, instead, nudge } = getSkipSheet(link);

  const chooseReason = option => !option.disabled && answer({ kind: 'skip', reason: option.dismissReason });
  const linkInstead = () => openPane('search');

  useWindowKeydown(e => {
    if (e.repeat || isKeysOpen || isTypingTarget(e.target) || e.metaKey || e.ctrlKey || e.altKey) return;
    const option = reasons.find(reason => reason.shortcut === e.key);
    if (e.key === 'Escape') closeSheet();
    else if (option) chooseReason(option);
    else if (e.key.toUpperCase() === instead.shortcut) linkInstead();
    else return;
    e.preventDefault();
  });

  return (
    <div className='skip-reason-sheet' role='dialog' aria-label={title}>
      <h3>{title}</h3>
      {reasons.map(option => (
        <button key={option.dismissReason} type='button' className='sheet-option' disabled={option.disabled} onClick={() => chooseReason(option)}>
          <span className='ltc-key'>{option.shortcut}</span>
          <span>
            <span className='option-title'>{option.display}</span>
            <span className='option-detail'>{option.detail}</span>
          </span>
        </button>
      ))}
      <hr />
      <button type='button' className='sheet-option' onClick={linkInstead}>
        <span className='ltc-key'>{instead.shortcut}</span>
        <span>
          <span className='option-title'>{instead.display}</span>
          <span className='option-detail'>{instead.detail}</span>
        </span>
      </button>
      {nudge && <div className='sheet-nudge'>{nudge}</div>}
    </div>
  );
};

export default SkipReasonSheet;
